import { useEffect, useRef } from 'react';

export function useUnmount(fn: Function) {
  const fnRef = useRef<Function>(fn);
  fnRef.current = fn;
  useEffect(
    () => () => {
      if (fnRef.current) {
        fnRef.current();
      }
    },
    [],
  );
}
/**
 * This hook spawns usefffect which watches the function-procedure and applies it when it has changed
 * @param fn a function without any arguments, a procedure
 */
export function useMount(fn: Function) {
  useEffect(() => {
    fn();
    // eslint-disable-next-line
  }, []);
}
